// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1aSyq","head":"Table_head__2S2jA","col":"Table_col__1Peb5"};